import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { installAuthFetchInterceptor } from './utils/installAuthFetchInterceptor'
import './index.css'
import App from './App.jsx'

installAuthFetchInterceptor()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

